import { useState } from "react";
import RevenueView from "./RevenueView";
import ProductView from "./ProductView";
import SalesSummaryView from "./SalesSummaryView";
import { useSelector } from "react-redux";
import ReportHeaderTabs from "../../../components/ReportHeaderTabs";
import { canOpen } from "../../../internals/config/moduleAccess";
import CollectionsReportView from "./CollectionsReportView";

const ReportView = () => {
  const [selectedTab, setSelectedTab] = useState("SALES_SUMMARY");
  const shopModules = useSelector((state: any) => state.setting.get("shopModules"));
  // Invoice collections and credit sales (Phase 7, P5) need the invoicing module.
  const invoicing = canOpen("/invoices", shopModules);

  const renderScreen = (tab: string) => {
    switch (tab) {
      case "SALES_SUMMARY":
        return (
          <div className="w-full p-6">
            <SalesSummaryView />
          </div>
        );
      case "COLLECTIONS":
        return (
          <div className="w-full p-6">
            <CollectionsReportView />
          </div>
        );
      case "REVENUE":
        return (
          <div className="w-full p-6">
            <RevenueView />
          </div>
        );
      default:
        return <ProductView />;
    }
  };

  return (
    <>
      <div className="w-full p-6">
        <ReportHeaderTabs
          selectedTab={selectedTab}
          onChange={(type: string) => setSelectedTab(type)}
          extraTabs={invoicing ? [{ title: "Collections", value: "COLLECTIONS" }] : []}
        />
      </div>
      {renderScreen(selectedTab)}
    </>
  );
};

export default ReportView;
